import { useEffect } from "react";
import useAppState from "../state/app.state";
import { useTranslation } from "react-i18next";

export default function LanguageService() {
  const { i18n } = useTranslation();
  const { language } = useAppState();

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [i18n, language]);

  return null;
}
